import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";

const NAV_LINKS = [
  { id: "beranda", label: "Beranda", testId: "nav-link-beranda" },
  { id: "tentang", label: "Tentang Kami", testId: "nav-link-tentang" },
  { id: "layanan", label: "Layanan", testId: "nav-link-layanan" },
  { id: "proyek", label: "Proyek", testId: "nav-link-proyek" },
  { id: "kontak", label: "Kontak", testId: "nav-link-kontak" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(`#${id}`);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
        scrolled || open
          ? "bg-navy/90 shadow-lg shadow-navy-dark/30 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
        <a
          href="#beranda"
          data-testid="nav-logo"
          onClick={(e) => go(e, "beranda")}
          aria-label="PT. Prime Karya Mandiri — kembali ke beranda"
        >
          <Logo />
        </a>

        <nav aria-label="Navigasi utama" className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              data-testid={link.testId}
              onClick={(e) => go(e, link.id)}
              className="group relative text-sm font-medium text-slate-200 transition-colors duration-300 hover:text-white"
            >
              {link.label}
              <span className="absolute -bottom-1.5 left-0 h-0.5 w-0 bg-orange-500 transition-[width] duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href="#kontak"
            data-testid="nav-cta-header"
            onClick={(e) => go(e, "kontak")}
            className="group inline-flex items-center gap-2 rounded-full bg-orange-500 px-5 py-2.5 text-sm font-bold text-white transition-colors duration-300 hover:bg-orange-600"
          >
            Konsultasi Gratis
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
          </a>
        </nav>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          aria-label={open ? "Tutup menu" : "Buka menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-white lg:hidden"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav
          aria-label="Navigasi seluler"
          className="border-t border-white/10 bg-navy/95 px-4 pb-6 pt-2 backdrop-blur-md lg:hidden"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              data-testid={`${link.testId}-mobile`}
              onClick={(e) => go(e, link.id)}
              className="block border-b border-white/5 py-3.5 text-base font-medium text-slate-200 transition-colors hover:text-orange-400"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#kontak"
            data-testid="nav-cta-header-mobile"
            onClick={(e) => go(e, "kontak")}
            className="mt-4 flex items-center justify-center gap-2 rounded-full bg-orange-500 px-5 py-3 text-sm font-bold text-white"
          >
            Konsultasi Gratis
            <ArrowRight className="h-4 w-4" />
          </a>
        </nav>
      )}
    </header>
  );
};
